import React from 'react'
import { useContext } from "react";
import { TeamsFxContext } from "./Context";
import "./TenantNotRegistered.css";

export default function TenantNotRegistered() {
  const { themeString } = useContext(TeamsFxContext);

  return (
    <div className={themeString === "default" ? "" : "dark"}>
    <div className="tenantnotregistered page">
      <div className="narrow page-padding">
        Your organization is not a registered CyberCare user. Please buy CyberCare through the <a href='https://azuremarketplace.microsoft.com/en/marketplace/apps?search=cybertwice'>Azure Marketplace</a>.
      </div>
    </div>
  </div> 
  )
}
